import { ChevronDown } from 'lucide-react'
import { cn } from '@/lib/utils'
import { CATEGORY_DOT_COLORS, CATEGORY_LABELS } from '@/types'
import type { WorkflowDefinitionCategory, WorkflowDefinitionSummary } from '@/types'
import { WorkflowDefinitionsGrid } from './WorkflowDefinitionsGrid'

type SectionCategory = WorkflowDefinitionCategory | 'Uncategorized'

interface WorkflowDefinitionCategorySectionProps {
  category: SectionCategory
  definitions: WorkflowDefinitionSummary[]
  isExpanded: boolean
  onToggle: () => void
  canDuplicate: boolean
  canToggle: boolean
  canTrigger: boolean
  canDelete: boolean
  onNavigate: (def: WorkflowDefinitionSummary) => void
  onDuplicate: (def: WorkflowDefinitionSummary) => void
  onToggleActive: (def: WorkflowDefinitionSummary) => void
  onTrigger: (def: WorkflowDefinitionSummary) => void
  onDelete: (def: WorkflowDefinitionSummary) => void
}

export function WorkflowDefinitionCategorySection({
  category,
  definitions,
  isExpanded,
  onToggle,
  canDuplicate,
  canToggle,
  canTrigger,
  canDelete,
  onNavigate,
  onDuplicate,
  onToggleActive,
  onTrigger,
  onDelete,
}: WorkflowDefinitionCategorySectionProps) {
  const sharedProps = {
    definitions,
    canDuplicate,
    canToggle,
    canTrigger,
    canDelete,
    onNavigate,
    onDuplicate,
    onToggleActive,
    onTrigger,
    onDelete,
  }

  return (
    <div data-testid={`category-section-${category}`}>
      <button
        type="button"
        onClick={onToggle}
        className="flex w-full items-center gap-3 rounded-lg px-3 py-2.5 hover:bg-muted transition-colors text-left"
        aria-expanded={isExpanded}
        data-testid={`category-section-header-${category}`}
      >
        <ChevronDown
          className={cn(
            'h-4 w-4 text-foreground transition-transform duration-200 shrink-0',
            isExpanded ? 'rotate-0' : '-rotate-90'
          )}
        />
        <span className={cn('h-2.5 w-2.5 rounded-full shrink-0', CATEGORY_DOT_COLORS[category])} />
        <span className="text-sm font-bold leading-[1.6] tracking-[0.015em] text-foreground">
          {CATEGORY_LABELS[category]}
        </span>
        <span className="inline-flex items-center justify-center h-4 w-4 rounded-full bg-button text-white text-[10px] font-semibold shrink-0">
          {definitions.length}
        </span>
      </button>

      {isExpanded && (
        <div className="mt-2">
          <WorkflowDefinitionsGrid {...sharedProps} />
        </div>
      )}
    </div>
  )
}
